/**
 * Dependencies
 */
import YouTubePlayer from "youtube-player";

require("es6-promise/auto");
window._ = require("lodash");
window.axios = require("axios");

/**
 * variables
 */
const test = null;
const scrollMonitor = require("scrollMonitor");
const EnquiryModal = require("./Modal/enquiryModal");
const ApplyModal = require("./Modal/applyModal");
const SubMenu = require("./Menu/SubMenu");
const Accordion = require("./FAQ/Accordion");
const Dropdown = require("./FAQ/DropDown");
const Video = require("./Video/Video");
const Breakpoint = require("./Responsive/Breakpoint");
const FaqData = require("./FAQ/getFaqData");
const HeroImages = require("./Hero/HeroImages");
const Navigation = require("./Menu/Navigation");
const SelectorDropdown = require("./FAQ/SelectorDropdown");
const EqualHeights = require("./Helpers/equalHeights");
const ProductControl = require("./Product/ProductControl");
const ScrollDown = require("./Helpers/scrollDown");
const PrivacyAccordion = require("./Privacy/PrivacyAccordion");
const Modal = require("./Modal/Modal");
const ProductVideo = require("./Product/ProductVideo");
const Animations = require("./Helpers/Animations");
const BlogUpdate = require("./Blog");

window.Breakpoint = Breakpoint;
Breakpoint.init();
window.addEventListener(
  "resize",
  () => {
    Breakpoint.refreshValue();
  },
  false
);

window.YouTubePlayer = YouTubePlayer;

/**
 * add in our responsive grid
 * for testing purposes // OnKeyDown
 */
document.onkeydown = require("./Helpers/OnKeyDown");

const newLocal = document.body;
const body = newLocal;

/**
 * Our Object to run all this
 * which is a class to help
 * us work with resizes
 */
class FwJs {
  constructor() {
    this.initLoad = false;
    this.reloaders = [];
  }

  init() {
    this.initLoad = true;
    this.reloaders.push(new Accordion());
    this.reloaders.push(new EnquiryModal());
    this.reloaders.push(new ApplyModal());
    this.reloaders.push(new HeroImages());
    this.reloaders.push(new Navigation());
    this.reloaders.push(new EqualHeights(".c-4colBlock__description", 3));
    this.reloaders.push(new EqualHeights(".c-applyRunner__equalHeight"));
    this.reloaders.push(new EqualHeights(".c-jobs__jobCard"));
    this.reloaders.push(new Video());

    new BlogUpdate();

    const subMenu = new SubMenu();
    const animate = new Animations();

    if (body.classList.contains("support")) {
      this.reloaders.push(new FaqData());
      const selector = new SelectorDropdown();
    }

    if (body.classList.contains("home")) {
      const scrollDown = new ScrollDown(".c-hero__dots", ".c-hero");
    }

    if (body.classList.contains("single-product")) {
      const scrollDown = new ScrollDown(".c-hero__dots", ".c-banner");
    }

    const control = new ProductControl();
    const privacy = new PrivacyAccordion();
    const modal = new Modal();
    const productVideo = new ProductVideo();
  }

  /**
   * the resizer runs all classes that assign
   * themselves the resize method
   */
  resize() {
    this.reloaders.forEach((element, index) => {
      if (typeof element.resize === "function") {
        element.resize();
      }
    });
  }
}

// CREATE the main object
const FwJsObj = new FwJs();

/**
 * one resize event listener needed which runs through all Our
 * classes that want to run resize events
 */
window.addEventListener(
  "resize",
  _.debounce(() => FwJsObj.resize(), 300),
  false
);

/**
 * lets get it ready (as in only use when dom content is ready)
 *
 * @param fn the function being passed in to be used
 */
function ready(fn) {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(FwJsObj.init());
